var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 3.50024C6.11217 3.50024 3.5 6.11241 3.5 9.33358V18.6669C3.5 21.8881 6.11217 24.5002 9.33333 24.5002H18.6667C21.8878 24.5002 24.5 21.8881 24.5 18.6669V9.33358C24.5 6.11241 21.8878 3.50024 18.6667 3.50024H9.33333ZM21 5.83358C21.644 5.83358 22.1667 6.35624 22.1667 7.00024C22.1667 7.64424 21.644 8.16691 21 8.16691C20.356 8.16691 19.8333 7.64424 19.8333 7.00024C19.8333 6.35624 20.356 5.83358 21 5.83358ZM14 8.16691C17.2212 8.16691 19.8333 10.7791 19.8333 14.0002C19.8333 17.2214 17.2212 19.8336 14 19.8336C10.7788 19.8336 8.16667 17.2214 8.16667 14.0002C8.16667 10.7791 10.7788 8.16691 14 8.16691ZM14 10.5002C13.0717 10.5002 12.1815 10.869 11.5251 11.5254C10.8687 12.1817 10.5 13.072 10.5 14.0002C10.5 14.9285 10.8687 15.8187 11.5251 16.4751C12.1815 17.1315 13.0717 17.5002 14 17.5002C14.9283 17.5002 15.8185 17.1315 16.4749 16.4751C17.1313 15.8187 17.5 14.9285 17.5 14.0002C17.5 13.072 17.1313 12.1817 16.4749 11.5254C15.8185 10.869 14.9283 10.5002 14 10.5002Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBlackIcon);
export default __webpack_public_path__ + "static/media/Instagram_black_icon.24a753f080d391beaf3914e415de85c4.svg";
export { ForwardRef as ReactComponent };